import React, { useCallback, useState } from "react";
import { prepareParams } from "./utils";
import { getUsers } from "../../store/api/users";
import UsersTable from "./UsersTable";

const Users = () => {
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [users, setUsers] = useState([]);

  const fetchData = useCallback((params) => {
    setLoading(true);
    getUsers(prepareParams(params))
      .then(({ data }) => {
        setUsers(data.users);
        setTotal(data.totalCount);
      })
      .catch(() => {
        // setError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <div className="page-wrapper">
      <h2 style={{ fontWeight: "bold" }}>Admin Users</h2>
      <UsersTable
        users={users}
        handleFetch={fetchData}
        loading={loading}
        total={total}
        showFilters={false}
      />
    </div>
  );
};

export default Users;
